import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import Modal from '@mui/material/Modal';

import './mobile-photo-review-detail-modal-style.scss';

import Button from '@src/componentsNew/Buttons/Button';
import MobileCustomHeader from '@src/componentsNew/Header/CustomHeader/MobileCustomHeader';

import { reviews_reviews_edges_node } from '@molecules/ReviewList/__generated__/reviews';

interface IProps {
  open: boolean;
  onClose: () => void;
  review: reviews_reviews_edges_node;
  imageIdx: number;
}

const MobilePhotoReviewDetailModal = ({ open, onClose, review, imageIdx }: IProps) => {
  const carouselRef = useRef();
  const [carouselIndex, setCarouselIndex] = useState(imageIdx);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        handleThumbnailClick(imageIdx);
      }, 0);
    }
  }, [open]);

  const handleThumbnailClick = (index: number) => {
    setCarouselIndex(index);
    // @ts-ignore
    carouselRef?.current?.slickGoTo(index);
  };

  const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: 'custom-review-slider',
    dotsClass: 'custom-dots',
    beforeChange: (_: number, next: number) => setCarouselIndex(next),
  };

  return (
    <Modal
      id="mobile-photo-review-detail-modal-container"
      open={open}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <div id="mobile-photo-review-detail-modal-content-wrapper">
        <MobileCustomHeader type="center" isShowBackBtn={true} onBackBtnClick={onClose} pageTitle="Photo Reviews" />

        <div className="photo-review-detail-content">
          <div className="review-image-area">
            <Slider ref={carouselRef} {...settings}>
              {review?.detailImages?.map((image) => (
                <img key={image.url} className="review-detail-carousel-img" src={image.url} />
              ))}
            </Slider>
          </div>

          <div className="review-info-images-preview">
            {review?.detailImages?.map((image, idx) => (
              <img
                key={image.url}
                className={`review-detail-carousel-img ${idx === carouselIndex ? 'active' : ''}`}
                src={image.url}
                onClick={() => handleThumbnailClick(idx)}
              />
            ))}
          </div>
        </div>

        <div className="close-btn-wrapper">
          <Button variant="outlined" size="large" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MobilePhotoReviewDetailModal;
